export const editTabsNav = {
    profile: {
        id: 'profile',
        name: 'Профиль',
        template: 'profile',
        pathName: 'patients_edit',
    },
    consultations: {
        id: 'consultations',
        name: 'Консультации',
        template: 'consultations',
        pathName: 'patients_consultations',
    },
    subscriptions: {
        id: 'subscriptions',
        name: 'Подписки',
        template: 'subscriptions',
        pathName: 'patients_subscriptions',
    },
    loyalty_cards: {
        id: 'loyalty_cards',
        name: 'Бонусные карты',
        template: 'loyalty_cards',
        pathName: 'patients_loyalty_cards',
    },
    conclusions: {
        id: 'conclusions',
        name: 'Заключения',
        template: 'conclusions',
        pathName: 'patients_conclusions',
    },
};